<template>
  <div>
    <b-container fluid class="tw-mb-5 tw-bg-gray-100 tw-border tw-border-blue-200" style="padding-bottom: 10px;">
      <!-- pull down menu -->
      <b-row class="tw-mt-2">
        <b-col cols="auto">
          <b-form-select size="lg" v-model="category" :options="categoryOptions"></b-form-select>
        </b-col>
      </b-row>
      <b-row class="tw-mt-2">
        <!-- BEGIN CHART -->
        <b-col md="12" lg="10" :xl="9" class="tw-overflow-x-scroll" ref="positiveInfectionsChartContainerChartContainer">
          <!-- add key to change chart plot -->
          <bar-chart
            v-if="loaded"
            :chartData="positiveInfections.chartdata"
            :options="positiveInfections.options"
            :styles="positiveInfections.myStyles"
            :key="componentKey"
          >
          </bar-chart>
          <span class="text-secondary tw-text-xs text-center" v-if="last_update">Last Updated: {{last_update}}</span>
        </b-col>
        <!-- END CHART -->
        <!-- BEGIN CARDS -->
        <b-col md="12" lg="2" :xl=3>
          <b-container>
            <b-row>
              <b-col lg="12" :xl=10 class="tw-p-1">
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      {{ category === "eleven_days"
                        ? "11 Day Wait"
                        : category === "fourteen_days"
                          ? "14 Day Wait"
                          : "All"
                      }} Infections
                    </h6>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">
                      {{ category_infections }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col lg="12" :xl=10 class="tw-p-1">
                <b-card>
                  <b-card-text>
                    <h6 class="tw-font-bolder tw-mb-0 text-center">
                      Total Ento
                    </h6>
                    <h1 class="tw-text-2xl tw-font-bolder text-center tw-mb-0">
                      {{ totalEnto }}
                    </h1>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
        <!-- END CARDS -->
      </b-row>
      <b-row>
        <b-col>
          <div class="text-right">
            <b-button :to="{ name: 'metrics-subject-infected-details'}" variant="outline-secondary">More</b-button>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import * as _ from "lodash";

import BarChart from "@/components/charts/BarChart.vue";

const totalCluster = 34;

export default {
  mixins: [],
  components: {
    BarChart,
  },
  props: {},
  data() {
    return {
      loaded: false,
      last_update: null,
      // pull down menu
      category: 'all',
      categoryOptions: [
        {value: 'all', text: 'All'},
        {value: 'eleven_days', text: '11 Day Wait'},
        {value: 'fourteen_days', text: '14 Day Wait'},
      ],
      category_infections: 0,
      componentKey: 0, // used to re-render chart component
      // infections
      evetubesInfections: 0,
      controlInfections: 0,
      totalInfections: 0,
      // ento
      evetubesEnto: 0,
      controlEnto: 0,
      totalEnto: 0,
      positiveInfections: {
        chartdata: {
          // make initial chart with empty data
          datasets: [
            // infections
            {
              label: "Infections",
              backgroundColor: "#37B1CA",
              data: Array(totalCluster).fill(0),
            },
            // Ento
            {
              label: "Ento",
              backgroundColor: "#a3d2e0",
              data: Array(totalCluster).fill(0),
            },
          ],
          labels: [
            "1 ET",
            "2 ET",
            "3 C",
            "4 C",
            "5 C",
            "6 C",
            "7 C",
            "8 ET",
            "9 C",
            "10 ET",
            "11 ET",
            "12 C",
            "13 ET",
            "14 C",
            "15 ET",
            "16 ET",
            "17 C",
            "18 ET",
            "19 C",
            "20 ET",
            "21 ET",
            "22 C",
            "23 ET",
            "24 C",
            "25 ET",
            "26 ET",
            "27 ET",
            "28 C",
            "29 C",
            "30 C",
            "31 C",
            "32 ET",
            "33 ET",
            "34 C"
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            position: "top",
            labels: {
              boxWidth: 18,
            },
          },
          title: {
            display: true,
            text: "Current Positive Infections",
          },
          animation: {
            animateScale: true,
            animateRotate: true,
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Cluster: ET = Eave Tube, C = Control",
                },
              },
            ],
            yAxes: [
              {
                stacked: false,
                gridLines: {
                  display: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Enrollment",
                },
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        },
        myStyles: {
          height: "25vh",
          width: "100vw",
          position: "relative",
        },
      },
    };
  },
  // watch category for pull down menu
  watch: {
    category: function() {
      this.get();
    },
  },
  mounted: function() {
    this.get();
  },
  methods: {
    capitalize: function(value){
        return _.capitalize(value);
    },
    get: function() {
      const that = this;

      // share the API with subject retention donut
      const params = {
        category: that.category,
      }

      HTTP.get("/eavetubes/metrics/positive-infections-chart/", { params: params })
        .then((response) => {

          // make cluster data: it can be non-existent (e.g., no cluster 1, etc.)
          // make zero arrays
          const dataArray = Array(totalCluster).fill(0)
          const dataArrayEnto = Array(totalCluster).fill(0)

          // fill data for infections
          response.data.data.forEach((element) => {
            dataArray[Number(element.cluster) - 1] = element.cluster_count;
          });

          // fill data for ento
          response.data.data_ento.forEach((element) => {
            dataArrayEnto[Number(element.cluster) - 1] = element.cluster_count;
          });

          // chart data
          that.positiveInfections.chartdata.datasets[0].data = dataArray;
          that.positiveInfections.chartdata.datasets[1].data = dataArrayEnto;

          // number of infections: tiles in the right
          that.eavetubesInfections = response.data.et_infections;
          that.controlInfections = response.data.control_infections;
          that.totalInfections = response.data.total_infections;

          that.category_infections = that.category === "eleven_days"
            ? response.data.total_infections_eleven_days
            : that.category === "fourteen_days"
              ? response.data.total_infections_fourteen_days
              : response.data.total_infections

          // number of infections: tiles in the right
          that.eavetubesEnto = response.data.et_ento;
          that.controlEnto = response.data.control_ento;
          that.totalEnto = response.data.total_ento;

          that.loaded = true;

          // refresh bar chart
          that.componentKey++

        })
        .catch((error) => {
          HandleErrors.HandleErrors(error);
        });
    },
    find: function() {},
    create: function() {},
    patch: function() {},
    update: function() {},
    delete: function() {},
  },
};
</script>

<style>
</style>
